<template>
  <div class="tw:pb-2">
    <p class="tw:text-xl tw:font-bold tw:text-gray-800">{{ name }}</p>
    <div class="tw:flex">
      <BaseStarsRating v-if="starRating > 0" class="tw:mr-2" :stars-number="starRating" />
      <p class="tw:text-gray-700">{{ lodgingTypeLabel }}</p>
    </div>
  </div>
</template>
<script setup>
import BaseStarsRating from '@/components/BaseStarsRating.vue'

defineProps({
  starRating: {
    type: Number,
    default: 0,
  },
  name: {
    type: String,
    default: '',
  },
  lodgingTypeLabel: {
    type: String,
    default: '',
  },
})
</script>
